import {Component, HostListener, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {MatOptionModule} from '@angular/material/core';
import {MatSelect, MatSelectModule} from '@angular/material/select';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {NgPipesModule} from 'ngx-pipes';
import {
  PageableParam,
  SearchCombinationTypeEnum,
  SearchFieldsDtoInput,
  SearchOperationType
} from '../../../interfaces/data.interfaces';

@Component({
    selector: 'app-table-advance-search',
    templateUrl: './table-advance-search.component.html',
    styleUrls: ['./table-advance-search.component.scss'],
    standalone: true,
    imports: [
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    MatOptionModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTooltipModule,
    NgPipesModule
]
})
export class TableAdvanceSearchComponent implements OnInit {

  receivedData: any;
  searchFields: SearchFieldsDtoInput[] = [{fieldName: 'createdAt', searchType: SearchOperationType.Between}];
  cacheAdvanceSearchFields: SearchFieldsDtoInput[];
  cacheSearchCombinationType: SearchCombinationTypeEnum = SearchCombinationTypeEnum.Or;

  title = 'Table Advance Search';

  roleFilterCtrl: UntypedFormControl = new UntypedFormControl();
  @ViewChild('columnSelect', { static: true }) columnSelect: MatSelect;

  form: UntypedFormGroup;

  protected readonly searchOperationType = SearchOperationType;
  protected readonly searchCombinationTypeEnum = SearchCombinationTypeEnum;

  constructor(
    private dialog: MatDialog,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.receivedData = data;

    if (this.receivedData?.searchFields?.length > 0) {
      this.searchFields.push(...this.receivedData?.searchFields);
    }

    if (this.receivedData?.cacheAdvanceSearchFields?.length > 0){
      this.cacheAdvanceSearchFields = this.receivedData?.cacheAdvanceSearchFields;
    }

    this.cacheSearchCombinationType = this.receivedData?.cacheSearchCombinationType;

  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    this.dialog.closeAll();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      searchCombinationType: [this.cacheSearchCombinationType],
      searchFields: this.fb.array([])
    });

    if (this.cacheAdvanceSearchFields?.length > 0){
      this.cacheAdvanceSearchFields.forEach(d => this.addSearchField(d));
    }else {
      this.addSearchField(null);
    }

  }

  onSearch(searchValue) {
    this.searchFields = this.searchFields?.filter( (v) =>
      v.fieldName?.toLowerCase().indexOf(searchValue?.toLowerCase()) > -1);
  }

  get getSearchFieldArray(): UntypedFormArray {
    return this.form.get('searchFields') as UntypedFormArray;
  }

  addSearchField(searchFieldsDtoInput: SearchFieldsDtoInput) {
    this.getSearchFieldArray.push(
      this.fb.group({
        fieldName: [searchFieldsDtoInput?.fieldName, Validators.required],
        fieldValue: [searchFieldsDtoInput?.fieldValue, Validators.required],
        fieldValueOne: [searchFieldsDtoInput?.fieldValues[0]],
        fieldValueTwo: [searchFieldsDtoInput?.fieldValues[1]],
        searchType: [searchFieldsDtoInput?.searchType, Validators.required]
      })
    );
  }

  removeSearchField(i: number) {
    this.getSearchFieldArray.removeAt(i);
  }

  modifiedValues(searchFieldsDtoInputs: SearchFieldsDtoInput[] | any[], searchCombinationType: SearchCombinationTypeEnum): PageableParam  {
    this.cacheSearchCombinationType = searchCombinationType;
    this.cacheAdvanceSearchFields = searchFieldsDtoInputs?.map( d => {
      let fieldValues = [];

      if (d?.searchType === SearchOperationType.In){
        fieldValues = d?.fieldValue?.split(',');
      }

      if (d?.searchType === SearchOperationType.Between){
        fieldValues = [d?.fieldValueOne, d?.fieldValueTwo];
      }

      return {
        fieldName: d?.fieldName,
        fieldValue: d?.fieldValue,
        searchType: d?.searchType,
        fieldValues,
      };
    });

    return {
        searchFields: this.cacheAdvanceSearchFields,
        searchCombinationType: this.cacheSearchCombinationType
    };
  }
}
